export default [
    "Starter",
    "Route 19 (Gras)",
    "Route 20 (Gras)",
    "Dausing-Hof (Gras)",
    "Vapydro City (Angeln)",
    "Vapydro-Werke (Gras)",
    "Route 4 (Gras)",
    "Wüstenresort (Gras)",
    "Relikt-Schloss (Höhle)",
    "Stratos-Kanalisation (Höhle)",
    "Alter Fluchtweg",
    "Stratos City(In der Kanalisation (Gras))",
    "Route 16 (Gras)",
    "Hain der Täuschung",
    "Lichtung",
    "Route 5 (Gras)",
    "Marea Zugbrücke",
    "Route 6 (Gras)",
    "Tarnpignon (Static)",
    "Sesokitz (Geschenk)",
    "Zorua (Geschenk)",
    "Eventura City (Surfer)",
    "Moor von Nevaio (Gras)",
    "Panaero-Höhle (Höhle)",
    "Elektrolithhöhle (Höhle)",
    "Route 7 (Gras)",
    "Turm der Himmelsfeste (Turm)",
    "Janosberg",
    "Bizarro-Raum",
    "Ondula",
    "Bucht von Ondula",
    "Route 14",
    "Route 13 (Gras)",
    "Lentimas-Tunnel (Höhle)",
    "Wunderbrücke (Karpador kaufen)",
    "Wonneira Ei (Septerna City Tor)",
    "Umkehrberg (Höhle)",
    "Route 12 (Gras)",
    "Dorfbrücke",
    "Route 9 (Gras)",
    "Route 11 (Gras)",
    "Route 22 (Gras)",
    "Route 21 (Gras)",
    "Abidaya City",
    "Seaside-Höhle (Höhle)",
    "Riesengrotte (Höhle)",
    "Route 23 (Gras)",
    "Siegesstraße (Höhle)",
    "Pokémon-Liga",
    "Route 22 (Static – Kobalium)",
    "Route 23 (Static – Terrakium)",
    "Route 13 (Static – Viridium)",
    "Riesengrotte (Static – Kyurem)",
    "Umkehrberg (Static – Heatran)",
    "Traumbrachland (Static – Latios/Latias)",
    "Stratos City Museum (Fossil)",
    "Naturreservat (Static – Shiny Maxax)",
    "Pokémon-Liga (Angeln)",
    "Fossil-1 ",
    "Fossil-2",
    "Fossil-3",
    "Fossil-4",
    "Fossil-5",
    "Extra-1",
    "Extra-2",
    "Extra-3",
    "Extra-4",
    "Extra-5",
    "Extra-6",
    "Extra-7",
    "Extra-8",
    "Extra-9",
    "Extra-10",
    "Shiny",
    "Mistmon of the Year"
];